module.exports = __webpack_public_path__ + "static/media/sharechat-3.eecda89c.webp";